import { type ComponentProps, memo, type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

export type BreadcrumbsSeparatorProps = ComponentProps<'div'> & {
  children?: ReactNode;
};

export const BreadcrumbsSeparator = memo(({ className, children = '/', ...restOfProps }: BreadcrumbsSeparatorProps) => {
  return (
    <div className={cn('shrink-0 font-medium text-12 text-inherit', className)} {...restOfProps}>
      {children}
    </div>
  );
});

BreadcrumbsSeparator.displayName = 'BreadcrumbsSeparator';
